import { down, up } from 'styled-breakpoints'
import styled from 'styled-components'

export const WhyChooseContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 450px;
  width: 100%;
  background-color: #f8f9fb;
  /* padding: 0px 140px; */
  margin-top: 50px;
  @media screen and (max-width: 962px) {
    height: auto;
  }
  ${down('md')} {
    margin: 32px 0px;
  }
`

export const Content = styled.div`
  ${up('md')} {
    margin: 0 auto;
    width: 1120px;
    max-width: 100%;
  }

  ${down('md')} {
    margin: 0 auto;
    max-width: 93%;
  }

  ${up('lg')} {
    max-width: 98%;
    margin: 0 auto;
  }
`
export const SnapCarouselWrapper = styled.div<{ isRTL: boolean; isTablet?: boolean }>`
  ${({ isRTL }) => (isRTL ? `margin-left: calc(50% - 50vw);` : `margin-right: calc(50% - 50vw);`)}

  ${({ isTablet, isRTL }) =>
    isTablet &&
    `
    & > div > div {
      ${isRTL ? `padding-left: 32%;` : `padding-right: 32%;`}
    }
  `}
`

export const WhyChooseHeading = styled.h2`
  color: #131717;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  margin: 67px 0px 30px 0px;
  @media screen and (max-width: 962px) {
    margin: 6px 0px 16px 0px;
    font-size: 20px;
  }
`

export const WhyChooseMain = styled.div``

export const WhyChooseCards = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  @media screen and (max-width: 962px) {
    flex-direction: column;
  }
`

export const WhyChooseCard = styled.div<{ isWingie: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  justify-content: start;
  height: ${(props) => (props.isWingie ? '95%' : '98%')};
  gap: 24px;
  padding: 24px;
  width: 100%;
  border: 1px solid transparent;
  background: #ffffff;
  box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.04), 0px 0px 8px 0px rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  margin: 0;
  transition-duration: 0.2s;
  transition-property: border, box-shadow;

  [dir='rtl'] && {
    text-align: right;
  }

  &:hover {
    border-radius: 8px;
    background: var(--greys-white, #fff);

    /* Elevations/Shadow 5 */
    box-shadow: 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  }
`

export const WhyChooseCardHeading = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #131717;
  margin-bottom: 4px;

  /* Enhanced Arabic typography */
  [dir='rtl'] & {
    line-height: 1.6;
    font-weight: 600;
  }
`

export const WhyChooseCardText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #131717;

  /* Enhanced Arabic typography */
  [dir='rtl'] & {
    line-height: 1.65;
    font-size: 15px;
  }
`

export const WhyChooseContainerSm = styled.div`
  margin: 30px 0px;
`
